import { useEffect } from 'react';
import useOrg from '@/contexts/OrgContext';
import { brandCss } from '@/lib/brandTheme';

// Puts the signed-in org's brand colour into the theme tokens for every screen,
// office and crew app alike. Renders nothing. Appended last in <head>, so it
// wins over index.css at equal specificity; removed again when there is no
// colour, which leaves the built-in palette exactly as it was.
export default function BrandTheme() {
  const { branding } = useOrg();
  const colour = branding?.colour;

  useEffect(() => {
    const css = brandCss(colour);
    let el = document.getElementById('brand-theme');
    if (!css) {
      el?.remove();
      return;
    }
    if (!el) {
      el = document.createElement('style');
      el.id = 'brand-theme';
      document.head.appendChild(el);
    }
    el.textContent = css;
  }, [colour]);

  return null;
}
